import { getUpdateData } from "./persisterService";
import { apiPatch } from "../Api/apiCall";
import { getProductData } from "../Product/ProductService/productService";
import { persistContractClaimSubEntities } from "./AbstractContractClaimPersister";
import { UseForm } from "../../types/UseForm";
import { ContractUnion } from "../../types/ContractUnion";

export const persistContractCase = async (updateData: UseForm["values"], origContractCase: ContractUnion) => {
  await persistContractClaimSubEntities(updateData, origContractCase);

  const apiUri = getProductData(origContractCase.productClassName, "apiUri");
  const contractCaseUpdateData = getUpdateData(updateData, origContractCase);

  await apiPatch(apiUri, origContractCase.id, contractCaseUpdateData);
};
